<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay" @click.self="close">
        <div class="custom-modal">
          <div class="modal-header">
            <h3>条目催更</h3>
            <button class="close-btn" @click="close">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
          
          <div class="modal-body">
            <div class="tip-text">
              提示：如果发现收录库版本落后于官方版本，请告诉我们！
            </div>
            
            <div class="input-group">
              <textarea
                  v-model="remark"
                  class="custom-textarea"
                  placeholder="请输入催更备注（例如：官方已更新到 x.x 版本）"
                  rows="4"
                  maxlength="100"
              ></textarea>
              <div class="word-limit">{{ remark.length }}/100</div>
            </div>
          </div>
          
          <div class="modal-footer">
            <button class="cancel-btn" @click="close">取消</button>
            <button 
              class="confirm-btn" 
              :disabled="loading"
              @click="submit"
            >
              <i v-if="loading" class="fa-solid fa-spinner fa-spin"></i>
              {{ loading ? '提交中...' : '确认催更' }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'UrgeUpdateModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'submit'],
  data() {
    return {
      remark: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.remark = ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    submit() {
      this.$emit('submit', this.remark)
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-dialog);

}

.custom-modal {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 80vh;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-family: '猫啃网糖圆体';
  font-size: 1.2em;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
}

.tip-text {
  margin-bottom: 15px; 
  color: #666; 
  font-size: 0.9em;
  line-height: 1.5;
}

.input-group {
  position: relative;
}

.custom-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  font-family: '爱点风雅黑', sans-serif;
  font-size: 14px;
  resize: none;
  background-color: #f9f9f9;
  color: #333;
  transition: all 0.3s;
  outline: none;
}

.custom-textarea:focus {
  border-color: #67c23a; /* Custom focus color matching button */
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(103, 194, 58, 0.1);
}

.word-limit {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  padding: 8px 20px;
  border: none;
  background: #f5f5f5;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.confirm-btn {
  padding: 8px 20px;
  border: none;
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%); /* Green gradient */
  color: white;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.confirm-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
}

/* Dark Theme Support */
.dark-theme .custom-modal {
  background: #2d2d2d;
  color: #fff;
}

.dark-theme .modal-header {
  border-bottom-color: #3d3d3d;
}

.dark-theme .modal-header h3 {
  color: #fff;
}

.dark-theme .close-btn {
  color: #aaa;
}

.dark-theme .tip-text {
  color: #aaa;
}

.dark-theme .custom-textarea {
  background: #383838;
  border-color: #444;
  color: #ccc;
}

.dark-theme .custom-textarea:focus {
  border-color: #67c23a;
  background: #2d2d2d;
}

.dark-theme .word-limit {
  color: #666;
}

.dark-theme .modal-footer {
  border-top-color: #3d3d3d;
}

.dark-theme .cancel-btn {
  background: #383838;
  color: #ccc;
}

.dark-theme .cancel-btn:hover {
  background: #444;
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-leave-active .custom-modal {
  transition: transform 0.3s ease-in;
}

.modal-fade-enter-from .custom-modal {
  transform: scale(0.9) translateY(10px);
}

.modal-fade-leave-to .custom-modal {
  transform: scale(0.95) translateY(10px);
}

@media (max-width: 480px) {
  .custom-modal {
    width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    margin: 0;
    max-width: none;
    max-height: 90vh;
  }
  
  .modal-overlay {
    align-items: flex-end; /* Bottom sheet style on mobile */
  }
  
  .modal-fade-enter-from .custom-modal,
  .modal-fade-leave-to .custom-modal {
    transform: translateY(100%);
  }
}
</style>
